import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function InlineError({ message, onRetry, className = '' }) {
  const { colors } = useTheme();
  return (
    <div
      className={`flex items-center justify-center gap-2 py-6 text-sm ${className}`}
      style={{ color: colors.secondaryText }}
    >
      <AlertTriangle size={14} style={{ color: '#f59e0b', flexShrink: 0 }} />
      <span>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-1 ml-1 underline underline-offset-2"
          style={{ color: colors.accent }}
        >
          <RefreshCw size={12} />
          Retry
        </button>
      )}
    </div>
  );
}
